import Campaigns from './campaignsResource';

import transformCSV from '@/api/shared/transformers/CSVTransformer';

import errorTransformer from '@/api/shared/transformers/errorTransformer';

import transformCampaignInfo from '@/api/shared/transformers/campaignInfoTransformer';

import normalizeNumbers from '@/utils/normalizeNumbers';

import parseRange from '@/api/shared/utility/parseRange';

function addCampaign(campaignData) {
  return Campaigns.save({}, normalizeNumbers(campaignData))
    .then(({ body: { message = '' } }) => {
      return message;
    })
    .catch(errorTransformer);
}

function getCampaigns(range) {
  return Campaigns.get(parseRange(range))
    .then(({ body: campaigns }) => campaigns)
    .catch(errorTransformer);
}

function getCampaignInfo(campaignId) {
  return Campaigns.get({ campaignId })
    .then(({ body: campaignInfo }) => transformCampaignInfo(campaignInfo))
    .catch(errorTransformer);
}

function updateCampaign({ campaignId, campaignInfo }) {
  return Campaigns.updateCampaign({ campaignId }, campaignInfo)
    .then(({ body: { message = '' } }) => message)
    .catch(errorTransformer);
}

function deleteCampaign(campaignId) {
  return Campaigns.delete({ campaignId })
    .then(({ body: { message = '' } }) => message)
    .catch(errorTransformer);
}

function saveCSV(range) {
  return Campaigns.saveCSV(parseRange(range))
    .then(res => transformCSV(res))
    .catch(errorTransformer);
}

function getOverall(campaignId, range) {
  return Campaigns.getOverall({
    campaignId,
    ...parseRange(range),
  })
    .then(({ body: stats }) => stats)
    .catch(errorTransformer);
}

function saveOverallCSV(campaignId, range) {
  return Campaigns.saveOverallCSV({
    campaignId,
    ...parseRange(range),
  })
    .then(res => transformCSV(res))
    .catch(errorTransformer);
}

export default {
  addCampaign,
  getCampaigns,
  updateCampaign,
  getCampaignInfo,
  deleteCampaign,
  saveCSV,
  getOverall,
  saveOverallCSV,
};
